module.exports = __webpack_public_path__ + "img/information_inspiring_design.6a96130.webp";